import React, { useEffect, useState } from 'react'
import { useAuth } from '../../modules/auth'
import { TablaExpedientes } from '../../components/TablaExpedientes/TablaExpedientes'
import axios from 'axios'
import { KTSVG } from '../../../_metronic/helpers'
import ReactPaginate from 'react-paginate'
import { Modal } from 'react-bootstrap'
import './Expedientes.css'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import PlanHeader from '../../components/PlanHeader/PlanHeader'

function Expedientes() {
  const API_URL = process.env.REACT_APP_API_URL
  const { currentUser } = useAuth()

  const [loadingPage, setLoadingPage] = useState(false)
  const [expedientes, setExpedientes] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [loadingNewExp, setLoadingNewExp] = useState(false)
  const [StatusValue, setStatusValue] = useState('')
  const [bulkCount, setBulkCount] = useState(0)

  const [showNewExp, setShowNewExp] = useState(false)
  const [showBulkLoad, setShowBulkLoad] = useState(false)

  const handleCloseNewExp = () => setShowNewExp(false)
  const handleShowNewExp = () => setShowNewExp(true)

  const handleCloseBulkLoad = () => {
    setShowBulkLoad(false)
    setBulkCount(0)
  }
  const handleShowBulkLoad = () => setShowBulkLoad(true)

  // ─────────────── FILTROS ───────────────
  let searchedExpedientes = []

  if (expedientes.length !== 0) {
    searchedExpedientes = expedientes.filter((expediente) => {
      if (searchValue !== '') {
        return (
          expediente.expediente.includes(searchValue) ||
          expediente.parteActora?.includes(searchValue) ||
          expediente.parteActora?.toLowerCase().includes(searchValue.toLowerCase())
        )
      } else if (StatusValue === 'TODOS' || StatusValue === '') {
        return expediente
      } else {
        return expediente.status.includes(StatusValue)
      }
    })
  }

  // ─────────────── PAGINACIÓN ───────────────
  const [currentPage, setCurrentPage] = useState(1)
  const recordsPerPage = 25

  const indexOfLastRecord = currentPage * recordsPerPage
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
  const currentRecords = searchedExpedientes.slice(indexOfFirstRecord, indexOfLastRecord)

  const paginate = ({ selected }) => setCurrentPage(selected + 1)

  // ─────────────── CARGAR EXPEDIENTES ───────────────
  const misExpedientes = () => {
    setLoadingPage(true)
    axios.get(API_URL + '/app/expedientes/' + currentUser.id)
      .then((response) => {
        setExpedientes(response.data)
        setLoadingPage(false)
      })
  }

  useEffect(() => {
    misExpedientes()
  }, [])

  // ─────────────── NUEVO EXPEDIENTE ───────────────
  const uploadNewExp = () => {
    setLoadingNewExp(true)
    const expName = document.getElementById('new-exp-name').value.replace(/ /g, '')
    const parteActora = document.getElementById('parte-actora').value

    axios.post(API_URL + '/app/newExp', {
      idUser: currentUser.id,
      expName,
      parteActora,
    })
      .then(() => {
        misExpedientes()
        setLoadingNewExp(false)
        handleCloseNewExp()
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se ha registrado el nuevo expediente',
          showConfirmButton: false,
          timer: 1500,
        })
      })
      .catch(() => {
        setLoadingNewExp(false)
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo registrar el expediente',
        })
      })
  }

  // ─────────────── CARGA MASIVA ───────────────
  const [file, setFile] = useState(null)

  function handleChange(event) {
    const file = event.target.files[0]
    setFile(file)

    const reader = new FileReader()
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result)
      const workbook = XLSX.read(data, { type: 'array' })
      const sheet = workbook.Sheets[workbook.SheetNames[0]]
      const rows = XLSX.utils.sheet_to_json(sheet)
      setBulkCount(rows.length)
    }
    reader.readAsArrayBuffer(file)
  }

  const uploadBulkLoad = () => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('idUser', currentUser.id)

    axios.post(API_URL + '/app/bulkLoad', formData, {
      headers: { 'content-type': 'multipart/form-data' },
    })
      .then(() => {
        misExpedientes()
        handleCloseBulkLoad()
        Swal.fire({
          icon: 'success',
          title: 'Expedientes cargados',
          timer: 1500,
          showConfirmButton: false,
        })
      })
      .catch((err) => {
        if (err.response?.status === 403 && err.response.data.error === 'PLAN_LIMIT') {
          Swal.fire({
            icon: 'error',
            title: 'Límite excedido',
            html: `Tu plan permite máximo <b>${err.response.data.allowed}</b> expedientes. Ya tienes <b>${err.response.data.current}</b> y el archivo contiene <b>${err.response.data.attempted}</b>.`,
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error inesperado',
            text: 'Intenta nuevamente.',
          })
        }
      })
  }

  // ─────────────── BORRAR ───────────────
  const deleteExpediente = (idExpediente) => {
  setLoadingPage(true)

  // Actualiza el estado inmediatamente
  setExpedientes(prev => prev.filter(e => e.id !== idExpediente))

  // 2Llama al backend
  axios.post(API_URL + '/app/deleteExp', { idExpediente })
    .then(() => {
      // Refresca para garantizar consistencia
      misExpedientes()
      setLoadingPage(false)
    })
    .catch(() => {
      // Si falló, vuelve a cargar desde backend
      misExpedientes()
      setLoadingPage(false)
    })
}

  return (
    <>
     <PlanHeader
  totalExpedientes={expedientes.length}
  onNew={handleShowNewExp}
  onBulk={handleShowBulkLoad}
  onRefresh={misExpedientes}
/>

      <div className='row gy-5 g-xl-8 card card-custom shadow mt-4 pb-10'>
        <div className='row p-6'>
          <div className='col-md-6'>
            <h2>Historial de expedientes</h2>
            <p>En este apartado podrás consultar los expedientes que se han dado de alta.</p>
          </div>

          <div className='col-md-3'>
            <select
              className="form-select"
              aria-label="Selecciona"
              onChange={(e) => setStatusValue(e.target.value)}
            >
              <option value="">FILTRAR POR</option>
              <option value="SURTIÓ EFECTOS">SURTIÓ EFECTOS</option>
              <option value="AÚN NO SURTE EFECTOS">AÚN NO SURTE EFECTOS</option>
              <option value="SIN NOTIFICACIONES">SIN NOTIFICACIONES</option>
              <option value="TODOS">TODOS</option>
            </select>
          </div>

          <div className='col-md-3 text-right'>
            <div className='form-group float-end pt-3'>
              <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 ms-0' />
              <input
                type='text'
                className='form-control form-control-flush ps-10 inicio-search-box mt-n10'
                placeholder='Buscar expediente...'
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value)
                  setCurrentPage(1)
                }}
              />
            </div>
          </div>
        </div>

        <div className='row mb-10 gy-5'>
          {!loadingPage && (
            <div className='expedientes'>
              <table className='table table-rounded table-hover table-row-bordered border gy-7 gs-7'>
                <thead>
                  <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200 expedientes-header'>
                    <th><b>Expediente</b></th>
                    <th><b>Parte Actora</b></th>
                    <th><b>Fecha Alta</b></th>
                    <th><b>Fecha Última<br />Notificación</b></th>
                    <th><b>Estatus</b></th>
                    <th><b>Acciones</b></th>
                  </tr>
                </thead>
                <tbody>
                  <TablaExpedientes expedientes={currentRecords} deleteExpediente={deleteExpediente} />
                </tbody>
              </table>
            </div>
          )}

          {loadingPage && (
            <div className='d-flex flex-center'>
              <h2>
                <span className='spinner-border spinner-border align-middle ms-2'></span>
                Cargando...
              </h2>
            </div>
          )}
        </div>

        <div className='row text-center'>
          <p>Mostrando {currentRecords.length} de {searchedExpedientes.length} resultados</p>
        </div>

        <ReactPaginate
          onPageChange={paginate}
          pageCount={Math.ceil(searchedExpedientes.length / recordsPerPage)}
          breakLabel={'...'}
          previousLabel={'< Anterior'}
          nextLabel={'Siguiente >'}
          containerClassName={'pagination'}
          pageLinkClassName={'page-number'}
          previousLinkClassName={'page-number'}
          nextLinkClassName={'page-number'}
          activeLinkClassName={'active'}
          forcePage={currentPage - 1}
        />
      </div>
    </>
  )
}

export { Expedientes }